// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { GenerateUID } from '@/mixins/helpers/GenerateUID'

// Import firebase
import { firebaseStorage } from '@/firebase/firebase-config'

export const UploadFileToStorage = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        GenerateUID

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        download_url: null,
        file_name: null,
        file_extension: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        uploadFileToStorageHandler: function(file, file_path, load) {

            try {

                /*
				**  Create image name and set the extension
				*/

				this.file_name = this.generateUID();
				this.file_extension = file.name.split('.').pop();
 
                /*
				**  Set the reference
				*/

				let storageRef = firebaseStorage.ref();

                /*
				**  Store the file
                **  @service: @Firebase/Storage
				*/

                storageRef.child(file_path + this.file_name + '.' + this.file_extension).put(file)
                .then((response) => {
 
                    /*
                    **  Upload completed successfully, now get the download URL
                    **  @service: @Firebase/Storage
                    */

					response.ref.getDownloadURL()
					.then(downloadURL => {

						/*
                        **  Set the download url prop
                        **  @prop: @here
                        */

                        this.download_url = downloadURL;

					})
					.then(() => {

                        /*
                        **  Filepond loading motions
                        **  @service: @Filepond
                        */

						load(file);

					})
					.catch((error) => {

						/*
                        **  Send to Bugsnag
                        **  @service: Bugsnag/BugsnagService
                        */

						this.reportBugsnagError({
							title: 'Get File Download URL',
							errorType: 'Firebase Storage',
							section: 'Events/Files',
                            uid: 'ushQziFaIaqXJJBKWTWI',
							error: error
						});

                        /*
                        **  Throw error message
                        **  @service: @SweetAlert2
                        */

						this.$swal('Uh Oh!', 'Looks like there was a problem processing your file.', 'error');

					});

                }).then(() => {

					/*
                    **  Throw success message
                    **  @service: @SweetAlert2
                    */

					this.$swal('Success!', 'Your lease document has been uploaded.', 'success');

				}).catch((error) => {

					// Send to bugsnag
					this.reportBugsnagError({
						title: 'Add Lease - Store Lease Document in Storage Error',
						errorType: 'Firebase Storage',
						section: 'Add Lease',
						component: 'AddLeaseMenu',
						error: error
					});

					// Throw error message
					this.$swal('Uh Oh!', 'Looks like there was a problem processing your document.', 'error');

				});

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Upload File to Storage.',
                    errorType: 'Application',
                    section: 'Events/Files',
                    uid: 'QU7tmG33nkBLMkuNgGNw',
                    error: e
                });

            }

        }

    }

}